import styled from 'styled-components';

export const MpTextbox = styled(`div`)`
	gap: 10px;
	display: flex;
	align-items: center;
	margin: 8px 0 24px 0;
	padding: 16px 24px;
	border: 1px solid #91d5ff;
	border-radius: 8px;
	background-color: #e6f7ff;
	font-size: 14px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
	}
`;
